module.exports = __webpack_public_path__ + "static/googled-202356566b30b7640ec80b2411611cb0.jpg";